import React, { useState } from "react";
import {
  MdVisibility,
  MdDomain,
  MdPerson,
} from "react-icons/md";
import WorkerReport from "./reports/WorkerReport";
import SectorReport from "./reports/SectorReport";

const PRIMARY = "#0e76a8";
const SECONDARY = "#f27405";

const reportCards = [
  {
    id: "workers",
    title: "Worker report",
    description: "Select a worker (operator or supervisor) and view their evaluation analytics and performance report.",
    icon: MdPerson,
    iconBg: "bg-emerald-500/10",
    iconColor: "text-emerald-600 dark:text-emerald-400",
  },
  {
    id: "sectors",
    title: "Sector report",
    description: "Select a sector and view workforce analytics and performance rankings.",
    icon: MdDomain,
    iconBg: "bg-[#0e76a8]/10",
    iconColor: "text-[#0e76a8]",
  },
];

export default function Reports() {
  const [viewReportId, setViewReportId] = useState(null);

  const backToCards = () => setViewReportId(null);

  return (
    <div className="p-4 md:p-6 pt-4 md:pt-6 space-y-6 max-w-[1100px] mx-auto">
      {!viewReportId ? (
        <>
          <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-between sm:items-start gap-4">
            <div className="space-y-1">
              <div className="flex items-center gap-2 mb-1">
                <span
                  className="px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-widest"
                  style={{ backgroundColor: `${SECONDARY}20`, color: SECONDARY }}
                >
                  Reports & Analytics
                </span>
              </div>
              <h2 className="text-slate-900 dark:text-white text-2xl md:text-3xl font-black tracking-tight">
                Reports & Analytics
              </h2>
              <p className="text-slate-500 dark:text-slate-400 text-sm md:text-base max-w-2xl">
                View analytics for workers, sectors, and supervisors. Select a report to open its analytics page.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {reportCards.map((card) => {
              const Icon = card.icon;
              return (
                <div
                  key={card.id}
                  className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden flex flex-col"
                >
                  <div className="p-4 sm:p-6 flex flex-col gap-4 flex-1">
                    <div className="flex items-start gap-3">
                      <span className={`p-2.5 rounded-xl shrink-0 ${card.iconBg} ${card.iconColor}`}>
                        <Icon className="text-xl" />
                      </span>
                      <div className="min-w-0">
                        <h3 className="font-black text-slate-900 dark:text-white text-lg">{card.title}</h3>
                        <p className="text-slate-500 dark:text-slate-400 text-sm mt-0.5">{card.description}</p>
                      </div>
                    </div>
                    <div className="mt-auto pt-2">
                      <button
                        type="button"
                        onClick={() => setViewReportId(card.id)}
                        className="w-full flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-white text-sm font-bold shadow-lg hover:opacity-90 transition-opacity"
                        style={{ backgroundColor: PRIMARY }}
                      >
                        <MdVisibility className="text-lg" />
                        View
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          {viewReportId === "workers" && <WorkerReport onBack={backToCards} />}
          {viewReportId === "sectors" && <SectorReport onBack={backToCards} />}
        </>
      )}
    </div>
  );
}
